'use client'

import { fetcher } from 'services/rest/fetcher'
import useSWRImmutable from 'swr/immutable'
import { env } from 'utils/envManager'

import type { Stock } from '../../../types/Stock'
import { type GetProductStockProps } from '../getProductStock'

export const useProductStock = ({
	language,
	country,
	productId,
	enabled,
}: GetProductStockProps) => {
	const basePath = `ws-online-orchestrator/v2/stock/products/${productId}`
	const searchParams = new URLSearchParams({
		countryIso: country,
		channelId: env.NEXT_PUBLIC_CHANNEL,
		language,
	})

	const url = new URL(basePath, env.NEXT_PUBLIC_SITE_BASE_URL)
	url.search = searchParams.toString()

	const fetchUrl = url.href

	const shouldFetch = enabled ?? true
	const { data, isLoading } = useSWRImmutable<Stock>(
		shouldFetch ? fetchUrl : null,
		fetcher,
		{
			revalidateOnMount: true,
		}
	)

	return { data, isLoading }
}
